<div class="assignee-strip" data-testid="inbox-assignee-strip" cdkOverlayOrigin #assignOrigin="cdkOverlayOrigin">
  @if ($assigneeState() === 'unassigned') {
    <button
      type="button"
      class="action-link"
      [disabled]="assigning()"
      [glxyPopover]="assignPopover"
      (click)="assignPopover.open()"
      [attr.aria-label]="'INBOX.STRIP.ASSIGN_CONVERSATION' | translate"
    >
      @if (assigning()) {
        <glxy-loading-spinner size="small"></glxy-loading-spinner>
      } @else {
        {{ 'INBOX.STRIP.ASSIGN' | translate }}
      }
    </button>
  } @else {
    @let user = selectedUser();
    @if (user) {
      @if (resolvingName() && !user.displayName) {
        <glxy-loading-spinner size="small"></glxy-loading-spinner>
      } @else {
        <glxy-avatar [width]="20" [name]="user.displayName || '?'"></glxy-avatar>
        <glxy-badge class="badge-label assignee-name" size="small" [color]="$badgeColor()">{{ user.displayName || ('INBOX.STRIP.UNKNOWN_USER' | translate) }}</glxy-badge>
      }
    }
    <button
      type="button"
      class="action-link"
      [disabled]="assigning()"
      [glxyPopover]="assignPopover"
      (click)="assignPopover.open()"
      [attr.aria-label]="'INBOX.STRIP.REASSIGN_CONVERSATION' | translate: { name: $safeNavigationMigration(user?.displayName) }"
    >
      @if (assigning()) {
        <glxy-loading-spinner size="small"></glxy-loading-spinner>
      } @else {
        {{ 'INBOX.STRIP.REASSIGN' | translate }}
      }
    </button>
  }

  <glxy-popover
    #assignPopover
    [origin]="assignOrigin"
    [closeOnBackdropClick]="true"
    [closeOnEscapeKey]="true"
  >
    <div class="assign-popover-content">
      @if ($assigneeState() !== 'assigned-to-me') {
        <button type="button" class="popover-action-row" (click)="assignToMe(); assignPopover.close()">
          <glxy-avatar [width]="24" [name]="'!' | translate"></glxy-avatar>
          <span>{{ 'INBOX.STRIP.ASSIGN_TO_ME' | translate }}</span>
        </button>
        <hr class="popover-divider" />
      }
      @if ($assigneeState() !== 'unassigned') {
        <button type="button" class="popover-action-row" (click)="assignUser(null); assignPopover.close()">
          <glxy-avatar [width]="24" [name]="'\u00D7' | translate" [backgroundColor]="'grey'"></glxy-avatar>
          <span>{{ 'INBOX.STRIP.REMOVE_ASSIGNEE' | translate }}</span>
        </button>
        <hr class="popover-divider" />
      }
      <glxy-form-field appearance="outline" size="small" bottomSpacing="none">
        <input
          matInput
          type="text"
          [formControl]="searchControl"
          [matAutocomplete]="userAuto"
          [placeholder]="'INBOX.STRIP.SEARCH_USERS' | translate"
          autocomplete="off"
        />
        <mat-autocomplete
          #userAuto
          [displayWith]="displayUser"
          (optionSelected)="onUserSelected($event); assignPopover.close()"
        >
          @for (user of users$ | async; track user?.userId) {
            <mat-option [value]="user">
              <div class="user-option">
              @if (user === null) {
                <glxy-avatar [width]="24" [name]="'?'" [backgroundColor]="'grey'"></glxy-avatar>
                <span class="user-option-name">Unassigned</span>
              } @else {
                <glxy-avatar [width]="24" [name]="user.displayName"></glxy-avatar>
                <span class="user-option-name">{{ user.displayName }}</span>
              }
              </div>
            </mat-option>
          }
          @if ((users$ | async)?.length === 0 && searchControl.value) {
            <mat-option disabled>{{ 'INBOX.STRIP.NO_USERS_FOUND' | translate }}</mat-option>
          }
        </mat-autocomplete>
      </glxy-form-field>
    </div>
  </glxy-popover>
</div>
